import type { ParamMatcher } from "@sveltejs/kit";

import { DASH_URLS } from "./dash";

export const match: ParamMatcher = (param) => {
  return !DASH_URLS.includes(param);
};

// Keep in sync with is_valid_subdomain_label in
// https://github.com/modal-labs/modal-client/blob/main/modal/_utils/name_utils.py
const WORKSPACE_NAME_PATTERN = /^(?![0-9]+$)(?!-)[a-z0-9-]{1,63}(?<!-)$/;

export const isValidWorkspaceName = (name: string): boolean => {
  return WORKSPACE_NAME_PATTERN.test(name);
};
